<template>
  <b-tab title="Teste de Equipamento" :active="ativo" class="m-0 p-0">
    <div id="screen-form" class="pl-2 pr-2 mt-2">
      <div id="TesteDeEquipamento">
        <b-container fluid>
          <!-- ::::::::::::::: PARTE SUPERIOR DO RELATORIO ::::::::::::::: -->
          <b-row>
            <b-col cols="3">
              <b-img :src="require('/static/images/netech.png')" fluid alt="Responsive image" width="230" />
            </b-col>

            <b-col cols="6" class="pt-4">
              <h4 class="exo-2 center-text p-4">{{ tipoDoTeste }}</h4>
            </b-col>

            <b-col cols="3" class="pl-5">
              <b-row><p class="m-0 p-0">ID. Relatório</p></b-row>
              <b-row><b-form-input size="sm" v-model="teste.numero" /></b-row>
              <b-row><p class="m-0 p-0">Data</p></b-row>
              <b-row>
                <b-form-datepicker
                  size="sm"
                  v-model="teste.data"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                />
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <!-- :::::::::::::::::           LATERAL ESQUERDA          :::::::::::::::::: -->
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <b-col cols="6" class="m-0 p-0 pr-1">
              <b-row class="m-0 p-0">
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>INFORMAÇÕES SOBRE O EQUIPAMENTO</strong>
                  </div>
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Descrição / Description</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.nome" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Identificação / Identification</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="identificacao" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Dimensões / Dimensions</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.dimensoes" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">Peso / Weight</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">{{ cargaDeTrabalho }}</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="equipamento.peso" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="equipamento.carga" />
                </b-col>
              </b-row>
            </b-col>
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <!-- :::::::::::::::::           LATERAL DIREITA           :::::::::::::::::: -->
            <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
            <b-col cols="6" class="m-0 p-0 pl-1">
              <b-row class="m-0 p-0">
                <b-col cols="12" class="p-0">
                  <div class="separador-div">
                    <strong>INFORMAÇÕES SOBRE O TESTE</strong>
                  </div>
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Local do Teste / Test Location</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="teste.local" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Procedimento / Procedure</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="teste.procedimento" />
                </b-col>
                <b-col cols="6" class="text-left p-0">
                  <p class="m-0 p-0">{{ cargaDeTeste }}</p>
                </b-col>
                <b-col cols="6" class="text-left p-0 pl-2">
                  <p class="m-0 p-0">Duração do Teste / Test duration</p>
                </b-col>
                <b-col cols="6" class="p-0">
                  <b-form-input size="sm" v-model="teste.teste" />
                </b-col>
                <b-col cols="6" class="p-0 pl-2">
                  <b-form-input size="sm" v-model="teste.duracao" />
                </b-col>
                <b-col cols="12" class="text-left p-0">
                  <p class="m-0 p-0">Resultado / Result</p>
                </b-col>
                <b-col cols="12" class="p-0">
                  <b-form-input size="sm" v-model="teste.resultado" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::           GRAFICO DO TESTE           :::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2 mb-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>REGISTRO DO TESTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="1" class="p-0"></b-col>
            <b-col cols="1" class="p-0 text-center">
              <div class="p-0 m-0">
                <apexchart ref="cartaTeste" width="900" type="area" :options="options" :series="series"></apexchart>
              </div>
            </b-col>
            <b-col cols="1" class="p-0"></b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- :::::::::::::::::           INSTRUMENTO DO TESTE           :::::::::::::::::: -->
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>INSTRUMENTO UTILIZADO</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="5" class="p-0">
              <b-form-input size="sm" v-model="teste.instrumento.descricao" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="teste.instrumento.serie" />
            </b-col>
            <b-col cols="2" class="p-0 pl-2">
              <b-form-input size="sm" v-model="teste.instrumento.capacidade" />
            </b-col>
            <b-col cols="3" class="p-0 pl-2">
              <b-form-input size="sm" v-model="teste.instrumento.certificado" />
            </b-col>
          </b-row>
          <!-- ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="mt-2">
            <b-col cols="12" class="p-0">
              <div class="separador-div">
                <strong>OBSERVAÇÕES</strong>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="p-0">
              <b-form-textarea v-model="teste.observacao" :rows="linhas" />
            </b-col>
          </b-row>
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <!-- ::::::::::::::::: PARTE INFERIOR DO RELATORIO DE LAUDO ::::::::::::::::: -->
          <!-- :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: -->
          <b-row class="text-left ml-2 mr-2">
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>RESPONSÁVEL</strong>
              </div>
            </b-col>
            <b-col cols="4" class="mt-2 p-0"> </b-col>
            <b-col cols="4" class="mt-2 p-0 pl-3 pr-3">
              <div class="separador-div">
                <strong>CLIENTE</strong>
              </div>
            </b-col>
          </b-row>
          <b-row class="text-left ml-2 mr-2 mb-2">
            <b-col cols="4">
              <responsavel-stamp
                :profissional="teste.inspetor"
                :preview="stampResponsavel"
                :posicao="'6rem'"
                key="resp-stamp-te"
              />
            </b-col>
            <b-col cols="4" class="m-0 p-0"> </b-col>
            <b-col cols="4">
              <div class="borda-cliente">
                <b-img
                  :src="logoCliente == null ? require('/static/images/sgcq_default.png') : logoCliente"
                  class="rounded-0"
                  fluid
                />
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <teste-modal ref="testeMod" @loadCertificado="loadCertificado($event)" @loadLegenda="loadLegenda($event)" />
    <carta-modal ref="cartaMod" @loadGrafico="loadGrafico($event)" />
    <!-- :::::::::::::::::::::::::::: COMANDOS DO RELATÓRIO :::::::::::::::::::::::::::: -->
    <div class="menu-acoes p-2">
      <div id="search-bar">
        <b-col cols="12" class="p-1 pr-0">
          <b-form inline>
            <h4 class="exo-1 m-0 mr-2">SGCQ</h4>
            <b-form-input id="sgcq-call" type="number" size="sm" class="m-1 p-1" placeholder="Sgcq" v-model="sgcq" />
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="primary" @click="loadEquipamento()">
              <b-icon icon="box-arrow-in-up-right" variant="light" scale="1.1" class="mr-2" />Buscar
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="info" @click="loadDetalhes()">
              <b-icon icon="file-earmark-richtext" variant="light" scale="1.1" class="mr-2" />Detalhes
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="warning" @click="loadCarta()">
              <b-icon icon="bar-chart-line-fill" variant="light" scale="1.1" class="mr-2" />Carta
            </b-button>
            <b-button size="sm" class="ml-1 pl-2 pr-3" variant="warning" v-print="printLaudo">
              <b-icon icon="printer" variant="light" scale="1.1" class="mr-2" />Imprimir
            </b-button>

            <b-form-radio-group
              id="radio-group-1"
              v-model="tipoDoTeste"
              name="radio-sub-component"
              buttons
              button-variant="outline-light"
              size="sm"
              class="conf-bar"
            >
              <b-form-radio value="TESTE DE CARGA">Teste de Carga</b-form-radio>
              <b-form-radio value="TESTE DE HIDROSTÁTICO">Teste Hidrostático</b-form-radio>
            </b-form-radio-group>

            <b-form-input id="size-lines" type="number" size="sm" class="m-1 p-1" v-model="linhas" />
          </b-form>
        </b-col>
      </div>
    </div>
  </b-tab>
</template>
<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useEquipamentoStore } from "@/stores/EquipamentoStore";
import StampCertificado from "@/components/supports/StampCertificado";
import Cliente from "@/models/Cliente";
import Equipamento from "@/models/Equipamento";
import Teste from "@/models_reports/Teste";
import Files from "@/http/files";
import TesteModal from "@/components/modals/relatorio/TesteModal";
import TesteCartaModal from "@/components/modals/relatorio/TesteCartaModal";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "CertificadoReport",

  components: {
    "teste-modal": TesteModal,
    "carta-modal": TesteCartaModal,
    "responsavel-stamp": StampCertificado,
    apexchart: VueApexCharts,
  },

  data() {
    return {
      sgcq: 0,
      ativo: false,
      teste: new Teste(),
      tipoDoTeste: "TESTE DE CARGA",
      cargaDeTrabalho: "Carga Trabalho / Work Load",
      cargaDeTeste: "Carga de Teste / Test Load",
      cliente: new Cliente(0, "Novo Cliente", "", "", "", "", "", "", ""),
      equipamento: new Equipamento(0, "Novo Equipamento", "", "", "", "", "", "", "", "", ""),
      identificacao: "",
      stampResponsavel: null,
      logoCliente: null,
      printLaudo: {
        id: "TesteDeEquipamento",
        popTitle: "SGCQ - Sistema de Gestão e Controle da Qualidade",
      },
      files: new Files(this.$http),
      linhas: 5,
      series: [{ name: "series", data: [] }],
      options: {
        chart: {
          id: "teste-chart",
          background: "#BABABA",
          toolbar: {
            show: false,
            autoSelected: "pan",
          },
          dataLabels: {
            enabled: true,
          },
        },
        xaxis: {
          show: true,
          categories: [0, 300, 600, 900, 1200, 1500, 1800],
          type: "numeric",
          title: {
            text: "Tempo(Segundos)",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },
        yaxis: {
          show: true,
          title: {
            text: "Carga/Pressão",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 600,
              cssClass: "apexcharts-xaxis-title",
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            shadeIntensity: 1,
            opacityFrom: 0.3,
            opacityTo: 0.1,
            stops: [0, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#EE0000", "#E91E63"],
        stroke: {
          show: true,
          curve: "smooth",
          lineCap: "round",
          width: 2,
        },
        title: {
          text: "CARTA GRÁFICA DE TESTE",
          align: "center",
        },
      },
    };
  },

  watch: {
    tipoDoTeste: function (newValue) {
      if (newValue == "TESTE DE CARGA") {
        this.cargaDeTrabalho = "Carga Trabalho / Work Load";
        this.cargaDeTeste = "Carga de Teste / Test Load";
      } else {
        this.cargaDeTrabalho = "Pressão Trabalho / Work Pressure";
        this.cargaDeTeste = "Pressão de Teste / Test Pressure";
      }
    },
  },

  methods: {
    loadEquipamento() {
      if (this.sgcq != 0 && this.sgcq != "") {
        this.equipamento.update(this.getBySgcq(this.sgcq)[0]);
        this.cliente.update(this.equipamento.cliente);
        this.equipamentoStore.LISTAR_SERVICOS(this.equipamento.sgcq).then(() => {
          let servicoData = new Date(this.getLastServico[0].data);
          this.teste.data = new Date(this.getLastServico[0].data);
          let ano = servicoData.getFullYear();
          this.teste.numero = "RN" + this.getLastServico[0].id + "-" + this.sgcq + "-" + ano + "-TE";
          this.identificacao = this.equipamento.sgcq;
          if (this.equipamento.codigo != "" && this.equipamento.codigo != "- - -") {
            this.identificacao = this.equipamento.sgcq + " - " + this.equipamento.codigo;
          }

          //carrega a logomarca do cliente
          this.files.downloadLogo(this.cliente.id).then((response) => {
            const reader = new FileReader();
            const blob = new Blob([response]);
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              this.logoCliente = e.target.result;
            };
          });
        });
      }
    },

    loadDetalhes() {
      this.$refs.testeMod.call(this.teste);
    },

    loadCarta() {
      this.$refs.cartaMod.call(this.teste);
    },

    loadGrafico(series) {
      this.series = series;
      this.loadLegenda();
    },

    loadLegenda() {
      if (this.tipoDoTeste == "TESTE DE CARGA") {        
        this.options.yaxis.title.text = "Carga(" + this.teste.unidade + ")";
        this.$refs.cartaTeste.updateOptions(this.options);
      } else {
        this.options.yaxis.title.text = "Pressão(" + this.teste.unidade + ")";
        this.$refs.cartaTeste.updateOptions(this.options);
      }
    },
  },

  setup() {
    const store = useSgcqStore();
    const equipamentoStore = useEquipamentoStore();
    const { getBySgcq } = storeToRefs(equipamentoStore);
    const { getLastServico } = storeToRefs(equipamentoStore);

    return {
      store,
      equipamentoStore,
      getBySgcq,
      getLastServico,
    };
  },
};
</script>

<style lang="scss" scoped>
.exo-1 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-style: italic;
  font-size: 1.4rem;
  padding: 0;
  color: white;
}

.exo-2 {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: italic;
  font-size: 1.8rem;
  text-align: center;
}

.center-text {
  text-align: justify; /* For Edge */
  text-align-last: center;
}

.separador-div {
  font-family: "Exo 2", sans-serif;
  font-optical-sizing: auto;
  background-color: #0066cc;
  border-radius: 4px;
  color: white;
  text-align: justify; /* For Edge */
  text-align-last: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

#screen-form {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 82vh;
}

#sgcq-call {
  width: 6rem;
}

#size-lines {
  width: 4rem;
}

.menu-acoes {
  background-color: #112a4a;
}

.borda-cliente {
  border: 1px solid lightgray;
  border-radius: 3px;
  padding-top: 1rem;
  padding-left: 3rem;
  min-height: 8.8rem;
}

.bordered {
  border: 1px solid lightgray;
}

.max-size {
  max-height: 20rem;
}

.conf-bar {
  margin-left: 15rem;
}
</style>
